import React from 'react'
import Button from '../../Button/Button'
import '../ReqestResponsePopup/ReqestResponseStyle.css';
import '../Deletepoup/DeletepoupStyle.css'

const Reqaccprej = ({ isActive, setIsActive, handleRejectRequest }) => {
    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>
            <div className="popupContainer deleteIconpoup">
                <div className="popupBody mb-30">
                    <div className="datadelete">
                        <img src="/assets/img/gif/AcceptReq.gif" alt="" className='reqacceptimg' />
                        <h3 className='headingpouptext'>Are you sure you want to reject this request ?</h3>
                    </div>
                </div>
                <div className="popupHeader gap-10">
                    <Button name={'Discard'} className={'btnnormal'} onClick={() => setIsActive(false)} />
                    <Button name={'Reject'} className={'btnnormal active'} onClick={handleRejectRequest} />
                </div>
            </div>
        </div>
    )
}

export default Reqaccprej